import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { propBool, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SeminarOneFormFieldDescription from '../Parts/SeminarOneFormFieldDescription';
import SeminarOneFormFieldTitle from '../Parts/SeminarOneFormFieldTitle';
import SeminarOneFormDateField from './SeminarOneFormDateField';
/**
 * セミナーのタイトル入力コンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormApplicationDeadlineField = (props) => {
    const { className, datepickerProps, disabled, input, meta } = props;
    return (_jsx(Element, Object.assign({ className: className, name: `${input.name}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_application_deadline' }, { children: [_jsx(SeminarOneFormFieldTitle, { className: 'application_deadline_title', text: '募集締切日' }), _jsx(SeminarOneFormFieldDescription, { className: 'application_deadline_description', text: 'セミナーの申込受付を終了する日時を登録してください' }), _jsx("div", Object.assign({ className: 'application_deadline_inner' }, { children: _jsx(SeminarOneFormDateField, { className: 'application_deadline_field', disabled: disabled, input: input, meta: meta, minDate: input.value ? undefined : datepickerProps.minDate, popperPlacement: 'bottom_start' }) }))] })) })));
};
SeminarOneFormApplicationDeadlineField.propTypes = {
    className: propStr(),
    datepickerProps: propShape().isRequired,
    disabled: propBool(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
SeminarOneFormApplicationDeadlineField.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormApplicationDeadlineField;
